<script>
import Bfhs from '@views/homepage/homepage-modules/homepage-bfhs'
import RecentlyPlayedMixes from '@views/homepage/homepage-modules/homepage-recently-played-mixes'
import FeaturedPlaylists from '@views/homepage/homepage-modules/homepage-featured-playlists'
import FeaturedCharts from '@views/homepage/homepage-modules/homepage-featured-charts'
import LatestMixes from '@views/homepage/homepage-modules/homepage-latest-mixes'
import TrendingMixes from '@views/homepage/homepage-modules/homepage-trending-mixes'
import HotDrops from '@views/homepage/homepage-modules/homepage-hot-drops'
import HomeRadio from '@views/homepage/homepage-modules/homepage-radio'
import TrendingDjs from '@views/homepage/homepage-modules/homepage-trending-djs'
import PremiumBanner from '@components/premium-banner'

export default {
    name: 'AuthHomepage',

    components: {
        Bfhs,
        RecentlyPlayedMixes,
        FeaturedPlaylists,
        FeaturedCharts,
        LatestMixes,
        TrendingMixes,
        HotDrops,
        HomeRadio,
        TrendingDjs,
        PremiumBanner,
    },
}
</script>

<template>
    <BaseSection
        padded
        class="homepage-container"
    >
        <Bfhs class="hero"/>
        <HotDrops />
        <PremiumBanner source="home-banner" />
        <TrendingMixes />
        <HomeRadio />
        <LatestMixes />
        <FeaturedPlaylists />
        <FeaturedCharts />
        <RecentlyPlayedMixes />
        <TrendingDjs />
    </BaseSection>
</template>

<style lang="scss" scoped>
@import '@design';

.homepage-container {
    display: grid;
    gap: $s-xxl;

    :deep(> *) {
        min-width: 100%;
    }

    @include tablet {
        &:has(> .hero) {
            grid-template-columns: minmax(0, 72%) minmax(0, 28%);

            :deep(> .hero:first-child) {
                grid-column: 2;
                grid-row: 1;
            }

            :deep(> .hero:first-child + *) {
                grid-column: 1;
                grid-row: 1;
            }

            :deep(> .hero:first-child ~ *:nth-child(n+3)) {
                grid-column: 1 / -1;
            }
        }
    }
}
</style>
